import { get } from 'lodash/fp';
import getByMode from '../../utils/getByMode';

import chuck from './chuck';
import mandi from './mandi';

export default itemId => (dispatch, getState) => {
  const configurationGuid = get(
    `estimateBuilder.entities.items.byId.${itemId}.itemProduct.configurationGuid`,
    getState(),
  );

  const designId = get(
    `estimateBuilder.entities.items.byId.${itemId}.designId`,
    getState(),
  );

  const designItemId = get(
    `estimateBuilder.entities.items.byId.${itemId}.itemId`,
    getState(),
  );


  const pipToCart = get(
    `estimateBuilder.entities.items.byId.${itemId}.itemProduct.pipToCart`,
    getState(),
  );

  return getByMode({
    chuck,
    mandi,
  })(configurationGuid, pipToCart, designItemId, designId);
};
